import React from 'react';
import Link from 'next/link';
import cn from 'classnames';
import { Container } from 'react-bootstrap';
import _get from 'lodash/get';
import _chunk from 'lodash/chunk';
import _truncate from 'lodash/truncate';
import useCategory from '@hooks/use-category';
import { useCategoryLazyQuery } from 'src/generated/graphql';
import { absoluteUrl, isServer } from '@lib/helpers';
import { ICategory } from '@server/data/models/category';
import { categoryHref, INTERNAL_URI } from '@helpers/route';
import {
  EVENT_CLASS_NAME,
  EVENT_ACTION_NAME,
  EVENT_CATEGORY,
  EVENT_LABEL,
} from '@helpers/events';

import * as S from './styles';

const MENU_SIZE = 6;
const mapSubCategory = {};
const remapData = (data: ICategory[]) => {
  const mainData = data.filter((item) => _get(item, 'parentId') == 1);
  mainData.forEach((parent) => {
    const categoryId = _get(parent, 'id');
    // if (_isUndefined(mapSubCategory[categoryId])) {
    mapSubCategory[categoryId] = [];
    data
      .filter((child) => _get(child, 'parentId') == categoryId)
      .forEach((child) => {
        mapSubCategory[categoryId].push({
          root: child,
          items: data.filter(
            (nextChild) => _get(nextChild, 'parentId') == _get(child, 'id')
          ),
        });
      });
    // }
  });

  return { mainData, mapSubData: mapSubCategory };
};

const MenuList = ({ categories }) => {
  const { mainData, mapSubData } = React.useMemo(() => remapData(categories), [
    categories,
  ]);

  const chunkItems = _chunk(mainData, MENU_SIZE);

  return (
    <S.MenuGrid>
      {(chunkItems || []).map((chunkCategory, index) => (
        <div key={index}>
          {chunkCategory.map((catLevel1) => {
            const id = _get(catLevel1, 'id');
            const subMenus = mapSubData[id] || [];
            const subMenuLength = _get(subMenus, 'length', 0) - 1;

            return (
              <S.MenuColumn key={`__level1${id}_${index}`}>
                <S.MenuSubHeading>
                  <Link href={categoryHref(id, _get(catLevel1, 'urlKey'))}>
                    <a
                      className={cn(EVENT_CLASS_NAME)}
                      data-category={EVENT_CATEGORY.CATEGORY_MAIN_MENU}
                      data-action={EVENT_ACTION_NAME}
                      data-label={_get(catLevel1, 'name')}
                    >
                      {_get(catLevel1, 'name')}
                    </a>
                  </Link>
                </S.MenuSubHeading>
                <p>
                  {subMenus.map(
                    ({ root: catLevel2, items }, subIndex: number) => {
                      const childMenuLength = _get(items, 'length', 0) - 1;

                      return (
                        <React.Fragment
                          key={`__level2${_get(catLevel2, 'id')}_${subIndex}`}
                        >
                          <Link
                            href={categoryHref(
                              _get(catLevel2, 'id'),
                              _get(catLevel2, 'urlKey')
                            )}
                          >
                            <a
                              className={cn(EVENT_CLASS_NAME)}
                              data-category={EVENT_CATEGORY.CATEGORY_CHILD_MENU}
                              data-action={EVENT_ACTION_NAME}
                              data-label={_get(catLevel2, 'name')}
                            >
                              {_get(catLevel2, 'name')}
                            </a>
                          </Link>
                          {subMenuLength > subIndex && <>&nbsp;/&nbsp;</>}

                          {/* {items.map((catLevel3, catLevel3Index) => (
                            <React.Fragment
                              key={`__level3${_get(
                                catLevel3,
                                'id'
                              )}_${catLevel3Index}`}
                            >
                              <Link
                                href={categoryHref(
                                  _get(catLevel3, 'id'),
                                  _get(catLevel3, 'urlKey')
                                )}
                              >
                                <a
                                  className={cn(EVENT_CLASS_NAME)}
                                  data-category={
                                    EVENT_CATEGORY.CATEGORY_CHILD_MENU
                                  }
                                  data-action={EVENT_ACTION_NAME}
                                  data-label={_get(catLevel3, 'name')}
                                >
                                  {_get(catLevel3, 'name')}
                                </a>
                              </Link>
                              {childMenuLength > catLevel3Index && (
                                <>&nbsp;/&nbsp;</>
                              )}
                            </React.Fragment>
                          ))} */}
                        </React.Fragment>
                      );
                    }
                  )}
                </p>
              </S.MenuColumn>
            );
          })}
        </div>
      ))}
    </S.MenuGrid>
  );
};

export const CategoryMenu = React.memo(() => {
  // const [
  //   loadCategory,
  //   { loading, error, data: categoryData, fetchMore },
  // ] = useCategoryLazyQuery();

  const dataCategory = useCategory();

  // React.useEffect(() => {
  //   if (!isServer) {
  //     window.document.onreadystatechange = () => {
  //       if (document.readyState === 'complete') {
  //         loadCategory({
  //           variables: {
  //             page: 1,
  //             limit: 9999,
  //             orderBy: 'position_on_menu|asc',
  //           },
  //         });
  //       }
  //     };
  //   }
  // }, []);

  const categories = _get(dataCategory, 'categories', []);

  return (
    <Container>
      <S.CategoryWrapper>
        <S.Title>Danh Mục Sản Phẩm</S.Title>
        {categories && <MenuList categories={categories} />}
      </S.CategoryWrapper>
    </Container>
  );
});

export default CategoryMenu;
